import { useMemo, useState } from "react";

import ToolBarThreeColumns from "components/Table/ToolBarThreeColumns";

import { BALANCES_STRINGS } from '../constants/strings';
import { GeneralNames } from "namesConstants/names";

import { debounce } from "utils/debounce";
import { Button } from 'primereact/button';

const TableForm = ({
  setSearchTextFilter,
  resetSearchTextFilter,
  onOpenDialog,
  onExportToExcel,
}) => {
  const [searchText, setSearchText] = useState("");

  const debouncedUpdate = useMemo(
    () =>
      debounce((value) => {
        setSearchTextFilter((prevFilters) => ({
          ...prevFilters,
          global: {
            ...prevFilters.global,
            value,
          },
        }));
      }, 500),
    [setSearchTextFilter],
  );

  const onUpdateSearchText = (e) => {
    const value = e.target.value;
    setSearchText(value);
    debouncedUpdate(value);
  };

  const onClearSearchText = () => {
    setSearchText("");
    resetSearchTextFilter();
  };

  const iconsData = [
    {
      icon: "excel",
      title: GeneralNames.GeneralExportToExcel,
      onClick: onExportToExcel,
    },
  ];

  return (
    <div
      role="search"
      aria-label="Filtros de saldos de vacaciones"
      className="flex items-center content-center"
    >
      <ToolBarThreeColumns
        value={searchText}
        clearTextLabel={onClearSearchText}
        onChange={onUpdateSearchText}
        placeholder="Buscar"
        iconsDataPanel={iconsData}
        iNeedDropdown={false}
        children = {
            <Button
              label='Cargar saldos'
              title='Cargar saldos'
              aria-label='Submit'
              type='submit'
              onClick= {onOpenDialog}
            />
        }
      />
    </div>
  );
};

export default TableForm;
